<template>
    <div :class="$style.footer">
        <VoteToggles :game="props.game" />
        <template v-if="!props.isGooglePlayShown">
            <InstallAppButton v-if="appStore.platform !== 'desktop' && !appStore.isNativeAppEnv" />
            <DiscordButton v-else />
        </template>
        <LoginMobileButton />
        <ShareButton :shareData />
    </div>
</template>

<script lang="ts" setup>
import InstallAppButton from '@/pages/Games/components/GameContainer/MobileFooter/InstallAppButton.vue'
import { useAppStore } from '@/store/app-store'
import type { APIGameType } from '@/types'

import VoteToggles from '../VoteToggles.vue'
import DiscordButton from './DiscordButton.vue'
import LoginMobileButton from './LoginMobileButton.vue'
import ShareButton from './ShareButton.vue'

const props = defineProps<{
    game: APIGameType | undefined
    shareData: ShareData
    isGooglePlayShown?: boolean
}>()
const appStore = useAppStore()
</script>

<style module>
.footer {
    display: flex;
    gap: 5px;
    flex-shrink: 0;
    width: 100%;
}

@media (--tablet-plus) {
    .footer {
        display: none;
    }
}
</style>
